// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomFab_root__HvaHq","small":"CustomFab_small__F3ubQ","medium":"CustomFab_medium__Zg5ZY","large":"CustomFab_large__15Ma5","primary":"CustomFab_primary__19aqX"};